import {
  Box,
  CircularProgress,
  Paper,
  PaperProps,
  Typography,
} from "@mui/material";
import React from "react";

import Row from "./Row";

interface CoreCardProps extends PaperProps {
  children: React.ReactNode;
  title?: string;
  isLoading?: boolean;
  extraHeaderActions?: React.ReactNode;
}

const CoreCard: React.FC<CoreCardProps> = ({
  children,
  sx = {},
  title,
  isLoading,
  extraHeaderActions,
  ...props
}) => {
  return (
    <Paper
      sx={{
        width: "100%",
        padding: 2,
        minHeight: "150px",
        height: "100%",
        ...sx,
      }}
      {...props}
    >
      {(title || extraHeaderActions) && (
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            width: "100%",
            justifyContent: "space-between",
            alignItems: "center",
            mb: 1.5,
          }}
        >
          {title ? <Typography variant="h5">{title}</Typography> : null}
          {extraHeaderActions}
        </Box>
      )}

      {isLoading ? (
        <Row
          sx={{
            height: "100%",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <CircularProgress size={24} sx={{ margin: "auto" }} />
        </Row>
      ) : (
        children
      )}
    </Paper>
  );
};

export default CoreCard;
